import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "displayName",
    standalone: true,
})
export class DisplayNamePipe implements PipeTransform {
  transform(displayName: string, fallback: string = "userHasNoName"): string {
    if (!displayName) {
      return fallback;
    }
    if (displayName.indexOf(",") > -1) {
      const parts = displayName.split(",");
      return parts[1].trim();
    }
    return displayName;
  }
}
